// Instant first paint for the Sports match list: last known list is kept in memory + localStorage
// and shown immediately while the live fetch refreshes it in the background.
const KEY = "bbw_matches_cache_v1";
let mem = null;

export function getCachedMatches() {
  if (mem) return mem;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const { data, at } = JSON.parse(raw);
      if (Array.isArray(data) && Date.now() - at < 6 * 60 * 60 * 1000) { mem = data; return data; }
    }
  } catch { /* ignore */ }
  return [];
}

export function setCachedMatches(data) {
  if (!Array.isArray(data)) return;
  mem = data;
  try { localStorage.setItem(KEY, JSON.stringify({ data, at: Date.now() })); } catch { /* quota */ }
}
